import { NetworkStatus, useQuery } from '@apollo/client';
import EvaluationFormTemplate from 'components/Forms/EvaluationFormTemplate';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import { useUser } from 'contexts/userContext';
import {
  GET_USER_BY_ID_QUERY,
  GET_USER_GOALS,
  GetUserByIdResponse,
  GetUserByIdVariables,
  GetUserGoalsResponse,
  GetUserGoalsVariables,
} from 'graphql/query/user';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { User } from 'types';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

const SelfEvaluationFormPage = () => {
  const { user: loggedInUser } = useUser();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const providedPeriod = searchParams.get('period');

  const { data: userGoals, networkStatus: userGoalsNetworkStatus } = useQuery<
    GetUserGoalsResponse,
    GetUserGoalsVariables
  >(GET_USER_GOALS, {
    variables: {
      user: loggedInUser?._id as string,
      year: getSelectedObjectiveGoalsYear(),
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  const { data: user, loading: loadingUser } = useQuery<GetUserByIdResponse, GetUserByIdVariables>(
    GET_USER_BY_ID_QUERY,
    {
      variables: {
        user: loggedInUser?._id as string,
        year: getSelectedObjectiveGoalsYear(),
      },
      fetchPolicy: 'network-only',
    }
  );

  const loadingUserGoals = userGoalsNetworkStatus === NetworkStatus.loading || !!!userGoals;

  useEffect(() => {
    if (user) {
      let isValidPeriod = true;
      if (
        !!providedPeriod &&
        !!!Number.isNaN(providedPeriod) &&
        +providedPeriod > 0 &&
        +providedPeriod < 4
      ) {
        if (+providedPeriod > (user?.getUserById.annualUserInfo?.period ?? 0))
          isValidPeriod = false;
      } else isValidPeriod = false;
      if (!isValidPeriod) {
        toast.error('This activity has not started yet.');
        navigate(-1);
      }
    }
  }, [user]);

  const calculateTitle = () => {
    switch (providedPeriod) {
      case '1':
        return `My Objective Settings - ${getSelectedObjectiveGoalsYear()}`;

      case '2':
        return `Mid Year Review - ${getSelectedObjectiveGoalsYear()}`;

      case '3':
        return `End Year Review - ${getSelectedObjectiveGoalsYear()}`;

      default:
        return '';
    }
  };

  return (
    <Navbar
      goBackButtonConfig={{
        title: calculateTitle(),
      }}
    >
      {loadingUserGoals || loadingUser ? (
        <LoadingIndicator />
      ) : (
        <EvaluationFormTemplate
          period={+(providedPeriod ?? '')}
          employee={user?.getUserById as User}
          initialRows={!!userGoals.getUserGoals.length ? userGoals.getUserGoals : undefined}
        />
      )}
    </Navbar>
  );
};

export default SelfEvaluationFormPage;
